import {Button, Datagrid, EditButton, ExportButton, List, ShowButton, TextField, TopToolbar, useListContext } from "react-admin";
import {useNavigate} from "react-router-dom";
import ControlPointIcon from '@mui/icons-material/ControlPoint';
import FilterListOffIcon from "@mui/icons-material/FilterListOff";
import CommonFilterCard, { CommonFilterField } from "../Common/CommonFilterCard";
import StyledDatagridWrapper, { commonDatagridSx } from "../Common/StyledDatagridWrapper";

const ListActions = (props: any) => {
    const { setFilters } = useListContext();
    const resetFilter = () => {
      setFilters({}, [], false);
    };
    const navigate = useNavigate();

    return (
      <TopToolbar>
        <Button
          variant="text"
          size={"small"}
          onClick={resetFilter}
          startIcon={<FilterListOffIcon />}
          label="Clear filters"
        />
        <Button
          variant="text"
          size={"small"}
          onClick={()=>{
            navigate("/AppConstants/create")
          }}
          startIcon={<ControlPointIcon />}
          label="Create"
        />
        <ExportButton/>
      </TopToolbar>
    );
};

const filterFields: CommonFilterField[] = [
    { type: "text", label: "Search by Name", source: "name" },
    { type: "text", label: "Search by Value", source: "value" },
];

const AppConstantList = (props:any) => {
    return (
        <List
            actions={<ListActions/>}
            sx={{
                "& .RaList-content": {
                    boxShadow: "none",
                    backgroundColor: "transparent",
                },
            }}
        >
            <>
            <CommonFilterCard fields={filterFields} />

            <br />

            <StyledDatagridWrapper title="App Constant">
            <Datagrid
                bulkActionButtons={false}
                sx={{
                    ...commonDatagridSx,
                    // Value can be very long; wrap it onto up to 3 lines instead
                    // of one nowrap line so the table doesn't scroll sideways.
                    "& .column-value": {
                        whiteSpace: "normal",
                        maxWidth: 360,
                        minWidth: 220,
                    },
                    "& .column-value .MuiTypography-root": {
                        display: "-webkit-box",
                        WebkitLineClamp: 3,
                        WebkitBoxOrient: "vertical",
                        overflow: "hidden",
                        wordBreak: "break-word",
                    },
                }}
            >
                <TextField source="id" />
                <TextField source="name" />
                <TextField source="value" />
                <ShowButton />
                <EditButton/>
            </Datagrid>
            </StyledDatagridWrapper>
            </>
        </List>
    )
}

export default AppConstantList;
